import { Link } from 'react-router';

import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Callout } from '../../../components/Callout';

import PagerExample from '../../components/pager/PagerExample';

export const Pager = () => (
    <div className='uikit-activity'>
        <Headline anchor='Pager'>Pager</Headline>
        <Playground example={<PagerExample />} />
        <Callout>
            See <Link to='/components/pager'>Pager</Link> for the actual React component.
        </Callout>
    </div>
);
